import {Component, Inject, Input, OnInit} from '@angular/core';
import {Newsletter} from "../../../shared/interface/newsletter";
import {DomSanitizer} from "@angular/platform-browser";
import {MAT_DIALOG_DATA} from "@angular/material/dialog";
import {Observable} from "rxjs";
export interface NewsletterSelectDialogData {
  newsletterObject: Newsletter;
}
@Component({
  selector: 'app-newsletter-pdf-view',
  templateUrl: './newsletter-pdf-view.component.html',
  styleUrls: ['./newsletter-pdf-view.component.scss']
})
export class NewsletterPdfViewComponent implements OnInit {

  @Input() newsletter: Observable<Newsletter>;
  @Input() showToolbar: boolean = true;
  @Input() zoom: string = 'page-fit';

  newsletterObject: Newsletter;
  constructor(
    private sanitizer: DomSanitizer,
    @Inject(MAT_DIALOG_DATA) public data: NewsletterSelectDialogData,
  ) {
    this.newsletterObject = data.newsletterObject;
  }
  ngOnInit(): void {

  }
}

